var _defs, _circle, _circle2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicFrutas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCE7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FBCFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fruitGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E11D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F1239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leafGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#059669"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 42,
    r: 6,
    fill: "#F43F5E",
    opacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 46,36 C 46,30 42,32 38,30",
    fill: "none",
    stroke: "#F43F5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28, 34)",
    filter: "drop-shadow(0px 3px 2px rgba(159, 18, 57, 0.2))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,-10 C -12,-10 -15,0 -12,10 C -9,20 9,20 12,10 C 15,0 12,-10 0,-10 Z",
    fill: "url(#fruitGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -3,-10 C 0,-7 0,-7 3,-10",
    fill: "none",
    stroke: "#9F1239",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,-9 C 0,-16 4,-18 7,-18",
    fill: "none",
    stroke: "#78350F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6,-18 C 11,-18 15,-15 14,-11 C 13,-7 7,-10 6,-18 Z",
    fill: "url(#leafGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -8,-2 C -10,4 -6,8 -6,8",
    fill: "none",
    stroke: "#FFE4E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicFrutas);
export default __webpack_public_path__ + "static/media/topic_frutas.f6660edd9d43380523172ca9d8e9f2ca.svg";
export { ForwardRef as ReactComponent };